export default "__VITE_ASSET__fNF8ldi6__"